import { create } from 'zustand';

type AuthView = 'login' | 'register';

interface AuthModalState {
  isOpen: boolean;
  view: AuthView;
  openLogin: () => void;
  openRegister: () => void;
  switchView: (view: AuthView) => void;
  close: () => void;
}

export const useAuthModalStore = create<AuthModalState>()((set) => ({
  isOpen: false,
  view: 'login',
  openLogin: () => set({ isOpen: true, view: 'login' }),
  openRegister: () => set({ isOpen: true, view: 'register' }),
  switchView: (view) => set({ view }),
  close: () => set({ isOpen: false }),
}));
